module.exports = __webpack_public_path__ + "static/media/ionicons.96f1c901.woff2";